import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { EmailAddressAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-executive-associate-email-audit-list',
  templateUrl: './person-profile-executive-associate-email-audit-list.component.html',
  styleUrls: ['./person-profile-executive-associate-email-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileExecutiveAssociateEmailAuditListComponent implements OnInit {
  @Input() executiveAssociateEmail: number;
  @Input() loading: boolean;
  @Input() executiveAssociateEmailAudits: EmailAddressAudit[];

  @Output() loadExecutiveAssociateEmailAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadExecutiveAssociateEmailAudits.emit(this.executiveAssociateEmail);
  }

  onNextPage() {
    this.nextPage.emit(this.executiveAssociateEmail);
  }
}
